export default __webpack_public_path__ + "768b455021e453747c9c90f55d275c08.png";